import { useEffect } from "react"
import { create } from "zustand"
import useMediaQuery from "../hooks/useMediaQuery"
import { useNavigation } from "./NavigationProvider"

const INIT_VIEWPORT = {
	width: 0,
	height: 0,
	active: true,
}

export const useViewportStore = create((set) => ({
	viewport: { ...INIT_VIEWPORT },
	setViewport: (newViewport) =>
		set((state) => ({
			viewport: {
				...state.viewport,
				...newViewport,
			},
		})),
	setActive: (active) =>
		set((state) => ({
			viewport: {
				...state.viewport,
				active,
			},
		})),
}))

export default function WindowSizeProvider() {
	const setViewport = useViewportStore((state) => state.setViewport)
	const setActive = useViewportStore((state) => state.setActive)
	const isLandscape = useMediaQuery("(orientation: landscape)")
	const isLoaded = useNavigation((state) => state.isLoaded)

	useEffect(() => {
		const handleResize = () => {
			setViewport({
				width: window.innerWidth,
				height: window.innerHeight,
			})
		}

		const handleVisibility = () => {
			const isActive = document.visibilityState !== "hidden"
			setActive(isActive)
		}

		handleResize()
		handleVisibility()

		const controller = new AbortController()
		window.addEventListener("resize", handleResize, { signal: controller.signal })
		document.addEventListener("visibilitychange", handleVisibility, { signal: controller.signal })

		return () => {
			controller.abort()
		}
	}, [isLandscape, isLoaded])

	return null
}
